import { ParseSpec } from 'prosemirror-markdown';
import { MarkSpec } from 'prosemirror-model';

import { BaseExtension, EditorOptions, extensionType } from '@lyearn/lygo-core';

import { markInputRule } from '../../utils';
import plugins from './plugins';

const STRIKETHROUGH_NODE_NAME = 'strikethrough';
const STRIKETHROUGH_REGEX = /~([^~]+)~$/;

export default class Strikethrough extends BaseExtension {
  get schema(): MarkSpec {
    return {
      parseDOM: [
        {
          tag: 's',
        },
        {
          tag: 'del',
        },
        {
          tag: 'strike',
        },
      ],
      toDOM: () => ['del', 0],
    };
  }

  get type(): string {
    return extensionType.mark;
  }

  get name(): string {
    return STRIKETHROUGH_NODE_NAME;
  }

  get markdownToken(): string {
    return 's';
  }

  parseMarkdown(): void | ParseSpec {
    return {
      mark: STRIKETHROUGH_NODE_NAME,
    };
  }

  inputRules({ schema }: EditorOptions) {
    return [markInputRule(STRIKETHROUGH_REGEX, schema.marks.strikethrough)];
  }

  plugins = plugins;
}
